//
// Mailgun Address Validation Plugin
//
// Attaching to a form:
//
//    $('jquery_selector').mailgun_validator({
//        api_key: 'api-key',
//        in_progress: in_progress_callback, // called when request is made to validator
//        success: success_callback,         // called when validator has returned
//        error: validation_error,           // called when an error reaching the validator has occured
//    });
//
//
// Sample JSON in success callback:
//
//  {
//      "is_valid": true,
//      "parts": {
//          "local_part": "john.smith@example.com",
//          "domain": "example.com",
//          "display_name": ""
//      },
//      "address": "john.smith@example.com",
//      "did_you_mean": null
//  }
//
// More API details: https://api.mailgun.net/v2/address
//


$.fn.mailgun_validator = function(options) {
    return this.each(function() {
        $(this).focusout(function() {
            run_validator($(this).val(), options);
        });
    });
};


function run_validator(address_text, options) {
    // don't run validator without input
    if (!address_text) {
        return;
    }

    // length check
    if (address_text.length > 512) {
        error_message = 'Stream exceeds maxiumum allowable length of 512.';
        if (options && options.error) {
            options.error(error_message);
        }
        else {
            window.console && console.log(error_message);
        }
        return;
    }

    // validator is in progress
    if (options && options.in_progress) {
        options.in_progress();
    }

    // require api key
    if (options && options.api_key == undefined) {
        window.console && console.log('Please pass in api_key to mailgun_validator.')
    }

    var success = false;
    window.emailValidateCount++;
    // make ajax call to get validation results
    $.ajax({
        type: "GET",
        url: 'https://api.mailgun.net/v2/address/validate?callback=?',
        data: { address: address_text, api_key: options.api_key },
        dataType: "jsonp",
        async:false,
        crossDomain: true,
        success: function(data, status_text) {
            success = true;
            window.successCount++;
            if (options && options.success) {
                options.success(data, options.curr_obj, options.reqFieldLength, options.getLength, options.agree_consent_state);
                if($(options.curr_obj).closest("form").attr("id") == "delivery_information_form" && window.emailValidateCount == window.successCount && window.isSubmit == true){
                    var size = 0;var validCount=0;
                    for (key in elemValidObj) {
                        if (elemValidObj.hasOwnProperty(key)) size++;
                        if(elemValidObj[key] == true) validCount++;
                    }
                    window.isSubmit = false;
                    if(validCount == size-1 && elemValidObj.email1 == undefined) $("#delivery_information_form").submit();
                }
            }
        },
        error: function(request, status_text, error) {
            success = true;
            error_message = 'Error occurred, unable to validate address.';

            if (options && options.error) {
                options.error(error_message);
            }
            else {
                window.console && console.log(error_message);
            }
        }
    });

    // timeout incase of some kind of internal server error
    setTimeout(function() {
        error_message = 'Error occurred, unable to validate address.';
        if (!success) {
            if (options && options.error) {
                options.error(error_message);
            }
            else {
                window.console && console.log(error_message);
            }
        }
    }, 30000);
}
